import { render } from "./EventCard.vue?vue&type=template&id=da8c3790&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=da8c3790&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-da8c3790"

export default script